import script from "./ViewAGroupTalkPostContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAGroupTalkPostContent.vue?vue&type=script&setup=true&lang=js"

import "./ViewAGroupTalkPostContent.vue?vue&type=style&index=0&id=20f66a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f66a42"]])

export default __exports__